import { isBrowser } from "@capioweb/ui-components/src"
import React from "react"
import { useLocation } from "react-router-dom"
import { isSessionStorageAvailable } from "../../../utils"
export interface HeaderContextValue {
	isStickyHeader: boolean
	isStartPage: boolean
	showSearchPopup: boolean
	setShowSearchPopup: React.Dispatch<React.SetStateAction<boolean>>
	showLoginWindowPopup: boolean
	setShowLoginWindowPopup: React.Dispatch<React.SetStateAction<boolean>>
}

export const HeaderContext = React.createContext<HeaderContextValue>({
	isStickyHeader: false,
	isStartPage: false,
	showSearchPopup: false,
	setShowSearchPopup: () => false,
	showLoginWindowPopup: false,
	setShowLoginWindowPopup: () => false,
})
export interface HeaderContextProviderProps {
	isStickyHeader: boolean
	children?: React.ReactNode
}

export const HeaderContextProvider: React.FC<HeaderContextProviderProps> = (
	props
) => {
	const [isStickyHeader, setIsStickyHeader] = React.useState(false)
	const [showSearchPopup, setShowSearchPopup] = React.useState(false)
	const [showLoginWindowPopup, setShowLoginWindowPopup] = React.useState(false)
	const [cookieConsent, setCookieConsent] = React.useState<boolean>(
		isBrowser() && document?.cookie.indexOf("CookieConsent") > -1
	)

	const isStartPage = useLocation().pathname === "/"

	React.useEffect(() => {
		setIsStickyHeader(props.isStickyHeader)
	}, [props.isStickyHeader])

	React.useEffect(() => {
		if (isBrowser()) {
			setCookieConsent(document?.cookie?.indexOf("CookieConsent") > -1)
		}
	}, [isBrowser() && document?.cookie])

	React.useEffect(() => {
		if (isSessionStorageAvailable()) {
			const hideLoginPopup = sessionStorage.getItem("hideLoginPopup")
			setShowLoginWindowPopup(isStartPage && hideLoginPopup !== "1")
		}
	}, [])

	return (
		<HeaderContext.Provider
			value={{
				isStickyHeader,
				showSearchPopup,
				isStartPage: isStartPage,
				setShowSearchPopup,
				showLoginWindowPopup,
				setShowLoginWindowPopup,
			}}
		>
			{props.children}
		</HeaderContext.Provider>
	)
}
